import React from "react";
import PropTypes from "prop-types";

export const ActiveIcon = ({ size = 16, color = "#10b981" }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" fill={color} opacity="0.1"/>
		<path d="M7.5 12l2.5 2.5 7-7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

ActiveIcon.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string
};

export const PendingIcon = ({ size = 16, color = "#f59e0b" }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" fill={color} opacity="0.1"/>
		<path d="M12 6v6l4 2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

PendingIcon.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string
};

export const ExpiredIcon = ({ size = 16, color = "#ef4444" }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" fill={color} opacity="0.1"/>
		<rect x="9" y="9" width="6" height="6" rx="1" fill={color}/>
	</svg>
);

ExpiredIcon.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string
};

export const OngoingIcon = ({ size = 16, color = "#3b82f6" }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" fill={color} opacity="0.1"/>
		<path d="M8 12h8M12 8v8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

OngoingIcon.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string
};

export const NoValidityIcon = ({ size = 16, color = "#6b7280" }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" fill={color} opacity="0.1"/>
		<path d="M8.5 8.5l7 7M8.5 15.5l7-7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

NoValidityIcon.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string
};